import portalRequest from '@/modules/portal-auth/request';

export interface CartItem {
  id: string;
  productId: string;
  productType: 'ORIGINAL_TEMPLATE' | 'BRAND_PRODUCT'; // 原创模板 or 品牌资料
  model: string;
  coverImage: string;
  price: number;
  quantity: number;
  stock: number;
  /** 货架状态：0 表示已下架。 */
  shelfStatus?: number | string;
  styleName?: string;
  materialName?: string;
  gradeName?: string;
  colorNameCn?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ApiResponse<T> {
  code: number;
  msg?: string;
  message?: string;
  data: T;
}

export interface CartOrder {
  id: string;
  orderId: string;
  totalAmount: number;
  totalQuantity: number;
  status: 'UNPAID' | 'PAID' | 'CLOSED' | 'REFUNDED';
  createTime: string;
  payTime?: string;
  transactionId?: string;
}

// 获取购物车列表
export function getCartList() {
  return portalRequest({
    url: '/api/portal/cart/list',
    method: 'get'
  }) as unknown as Promise<ApiResponse<CartItem[]>>;
}

// 添加到购物车
export function addToCart(data: {
  productId: string;
  productType: 'ORIGINAL_TEMPLATE' | 'BRAND_PRODUCT';
  quantity: number;
}) {
  return portalRequest({
    url: '/api/portal/cart/add',
    method: 'post',
    data
  }) as unknown as Promise<ApiResponse<any>>;
}

// 更新购物车商品数量
export function updateCartQuantity(cartId: string, quantity: number) {
  return portalRequest({
    url: `/api/portal/cart/update/${cartId}`,
    method: 'put',
    data: { quantity }
  }) as unknown as Promise<ApiResponse<any>>;
}

// 删除购物车商品
export function removeFromCart(cartId: string) {
  return portalRequest({
    url: `/api/portal/cart/remove/${cartId}`,
    method: 'delete'
  }) as unknown as Promise<ApiResponse<any>>;
}

// 批量删除
export function batchRemoveFromCart(cartIds: string[]) {
  return portalRequest({
    url: '/api/portal/cart/batchRemove',
    method: 'post',
    data: { cartIds }
  }) as unknown as Promise<ApiResponse<any>>;
}

// 清空购物车
export function clearCart() {
  return portalRequest({
    url: '/api/portal/cart/clear',
    method: 'delete'
  }) as unknown as Promise<ApiResponse<any>>;
}

// 获取购物车商品总数
export function getCartCount() {
  return portalRequest({
    url: '/api/portal/cart/count',
    method: 'get'
  }) as unknown as Promise<ApiResponse<number>>;
}

// 创建购物车订单
export function createCartOrder(data: {
  cartIds: string[];
}) {
  return portalRequest({
    url: '/api/portal/cart/order/create',
    method: 'post',
    data
  }) as unknown as Promise<ApiResponse<any>>;
}

// 查询购物车订单支付状态
export function getCartOrderStatus(orderId: string) {
  return portalRequest({
    url: '/api/portal/cart/order/status',
    method: 'get',
    params: { orderId }
  }) as unknown as Promise<ApiResponse<any>>;
}

// 为已有待支付订单重新生成支付二维码
export function getCartOrderPayQrcode(orderId: string) {
  return portalRequest({
    url: '/api/portal/cart/order/pay',
    method: 'post',
    params: { orderId }
  }) as unknown as Promise<ApiResponse<any>>;
}

// 取消购物车订单
export function cancelCartOrder(orderId: string) {
  return portalRequest({
    url: '/api/portal/cart/order/cancel',
    method: 'post',
    data: { orderId }
  }) as unknown as Promise<ApiResponse<any>>;
}

// 获取购物车订单列表
export function getCartOrderList() {
  return portalRequest({
    url: '/api/portal/cart/order/list',
    method: 'get'
  }) as unknown as Promise<ApiResponse<CartOrder[]>>;
}
